import { Link } from "react-router-dom";
import ImageUrl from "../image-url/ImageUrl";
import { Button } from "components/ui/button";
import { qrFlipFlopAndroid, qrFlipFlopIOS } from "assets";

export default function QrDevicesDetection() {
  const userAgent = navigator.userAgent;
  const qrDetecting = () => {
    // IOS
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return (
        <div className="mt-2 ">
          <div className="flex justify-center mb-2">
            <ImageUrl width={100} height={100} src={qrFlipFlopIOS} alt="logo" />
          </div>

          <Link to="https://apps.apple.com/us/app/flipflop-social-network/id6465576581">
            <Button className="font-semibold text-sm">
              Yes, I want to download!
            </Button>
          </Link>
          <p className="text-center">
            FlipFlop is a social media app dedicated to short-form videos
            created for and consumed by users. The length of the videos is 15
            seconds to 15 Minutes. The format lends itself to entertainment and
            comedy. However, it is increasingly used for infotainment. So-called
            influencers who gain a steady audience on FlipFlop offer snippets of
            advice and tips along with self-promotion. Beauty, fashion, personal
            finance, and cooking are all popular topics for informational
            videos. Increasingly, the format is used to promote and sell
            products. Like all social media companies, FlipFlop has been the
            target of persistent concerns about the potential use or misuse of
            the private information that it gathers about its users. The
            difference is that the majority of FlipFlop is Cambodia-owned.
          </p>
        </div>
      );
    }
    // ANDROID
    else if (/android/i.test(userAgent)) {
      return (
        <div className="mt-2">
          <div className="flex justify-center mb-2">
            <ImageUrl
              width={100}
              height={100}
              src={qrFlipFlopAndroid}
              alt="logo"
            />
          </div>
          <Link to="https://play.google.com/store/apps/details?id=com.maxx4business.flip_flop&hl=en">
            <Button className="font-semibold text-sm">
              Yes, I want to download!
            </Button>
          </Link>
          <p className="text-center">
            FlipFlop is a social media app dedicated to short-form videos
            created for and consumed by users. The length of the videos is 15
            seconds to 15 Minutes. The format lends itself to entertainment and
            comedy. However, it is increasingly used for infotainment. So-called
            influencers who gain a steady audience on FlipFlop offer snippets of
            advice and tips along with self-promotion. Beauty, fashion, personal
            finance, and cooking are all popular topics for informational
            videos. Increasingly, the format is used to promote and sell
            products. Like all social media companies, FlipFlop has been the
            target of persistent concerns about the potential use or misuse of
            the private information that it gathers about its users. The
            difference is that the majority of FlipFlop is Cambodia-owned.
          </p>
        </div>
      );
    }
    // Other Device
    else {
      return (
        <div className="mt-2 w-full">
          <div className="flex justify-evenly w-full mb-2">
            <div>
              <p className="font-semibold text-sm">App Store</p>
              <ImageUrl
                width={200}
                height={200}
                src={qrFlipFlopIOS}
                alt="ios-qr"
              />
            </div>
            <div>
              <p className="font-semibold text-sm">Google Play</p>
              <ImageUrl
                width={200}
                height={200}
                src={qrFlipFlopAndroid}
                alt="android-qr"
              />
            </div>
          </div>
          <p className="text-center">
            FlipFlop is a social media app dedicated to short-form videos
            created for and consumed by users. The length of the videos is 15
            seconds to 15 Minutes. The format lends itself to entertainment and
            comedy. However, it is increasingly used for infotainment. So-called
            influencers who gain a steady audience on FlipFlop offer snippets of
            advice and tips along with self-promotion. Beauty, fashion, personal
            finance, and cooking are all popular topics for informational
            videos. Increasingly, the format is used to promote and sell
            products. Like all social media companies, FlipFlop has been the
            target of persistent concerns about the potential use or misuse of
            the private information that it gathers about its users. The
            difference is that the majority of FlipFlop is Cambodia-owned.
          </p>
        </div>
      );
    }
  };
  return <>{qrDetecting()}</>;
}
